module.exports = __webpack_public_path__ + "img/fd-welcome.04269f18.png";